import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-getting-started-reviewing-content',
  templateUrl: './help-getting-started-reviewing-content.component.html',
  styleUrls: ['./help-getting-started-reviewing-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGettingStartedReviewingContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
